<template>
  <div class="payout-detail__box">
    <div
      class="payout-detail__box-item"
      v-for="(doubleChangeItem, doubleChangeItemIndex) in RS_DOUBLE_CHANCE"
      :key="doubleChangeItemIndex"
    >
      <h3
        v-if="doubleChangeItem.title !== ''"
        class="payout-detail__box-item-title"
      >
        {{ getTranslatedText(doubleChangeItem.title) }}
      </h3>
      <table
        class="payout-detail__table"
        v-for="(tableItem, tableItemInDex) in doubleChangeItem.dataTable"
        :key="tableItemInDex"
      >
        <tr v-if="tableItem.titleTable !== ''">
          <td :colspan="tableItem.colspan" class="payout-detail__table-top-td">
            <div class="payout-detail__table-top">
              <span class="payout-detail__table-top-text uppercase">
                {{ getTranslatedText(tableItem.titleTable) }}
              </span>
              <span class="payout-detail__table-top-text uppercase">
                {{
                  getTranslatedText(tableItem.descriptionTable, {
                    first: tableItem.descriptionKeyFirst,
                    last: tableItem.descriptionKeyLast,
                  })
                }}
              </span>
            </div>
          </td>
        </tr>
        <tr>
          <td
            v-for="headerItem in tableItem.dataTableHeader"
            :colspan="headerItem.colspan"
            class="payout-detail__table-top-td"
            :key="headerItem.title"
          >
            <span class="payout-detail__table-text">
              {{
                getTranslatedText(headerItem.title, {
                  number: headerItem.key,
                })
              }}
            </span>
          </td>
        </tr>
        <tr
          v-for="(contentItem, contentItemIndex) in tableItem.dataTableContent"
          :key="contentItemIndex"
        >
          <td>
            <span class="payout-detail__table-text">
              {{
                getTranslatedText(contentItem.number, {
                  number: contentItem.keyNumber,
                })
              }}
            </span>
          </td>
          <td>
            <span class="payout-detail__table-text">
              {{
                getTranslatedText(contentItem.first, {
                  number: contentItem.keyFirst,
                })
              }}
            </span>
          </td>
          <td>
            <span class="payout-detail__table-text">
              {{
                getTranslatedText(contentItem.last, {
                  number: contentItem.keyLast,
                })
              }}
            </span>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import languageMixins from "@/mixins/language/language-mixins";
import { RS_DOUBLE_CHANCE } from "@/resources/data/payouts";

export default {
  mixins: [languageMixins],
  data() {
    return {
      RS_DOUBLE_CHANCE,
    };
  },
};
</script>
<style lang="scss">
@import "~ThemePath/scss/payouts/_payout-detail.scss";
</style>
